import { createContext, useContext, useState, useEffect } from "react";
import posthog from "posthog-js";
import { PH_KEY, PH_CONFIG } from "@/lib/posthog-config";

const ConsentContext = createContext(null);

function getStoredConsent() {
  if (typeof window === "undefined") return null;
  try { return localStorage.getItem("cookie-consent"); } catch (e) { return null; }
}

function setStoredConsent(value) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem("cookie-consent", value);
  } catch (e) {
    // Ignore storage errors
  }
}

export function ConsentProvider({ children }) {
  const [consent, setConsent] = useState(getStoredConsent);

  useEffect(() => {
    posthog.init(PH_KEY, PH_CONFIG);
  }, []);

  useEffect(() => {
    if (consent === "accepted") {
      posthog.opt_in_capturing();
      window.loadAdSense?.();
    } else if (consent === "declined") {
      posthog.opt_out_capturing();
    }
  }, [consent]);

  const accept = () => {
    setStoredConsent("accepted");
    setConsent("accepted");
  };

  const decline = () => {
    setStoredConsent("declined");
    setConsent("declined");
  };

  return (
    <ConsentContext.Provider value={{ consent, accept, decline }}>
      {children}
    </ConsentContext.Provider>
  );
}

export function useConsent() {
  return useContext(ConsentContext);
}
